/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { ComplexDependencies } from './dependenciesComplexClass.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createAtanh } from '../../factoriesAny.js';
export var atanhDependencies = {
  ComplexDependencies,
  typedDependencies,
  createAtanh
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesAtanh.generated.js
// module id = 1311
// module chunks = 2